const theme = {
  '--background': '#242438',

  '--primary': '#C74BD3',
  '--primary-dark-1': '#C556D4',
  '--primary-dark-2': '#C563D6',
  '--primary-light-1': '#B748C6',
  '--primary-light-2': '#A945B9',

  '--secondary': '#9147CC',
  '--secondary-transparent': 'rgba(126, 27, 204, 0.85)',
  '--secondary-dark-1': '#975ACD',
  '--secondary-dark-2': '#9A60CF',
  '--secondary-light-1': '#8244B8',
  '--secondary-light-2': '#7440A4',

  '--neutral': '#BEC5E0',
  '--neutral-dark-1': '#C4CAE1',
  '--neutral-dark-2': '#CBD1E3',
  '--neutral-dark-3': '#E0E6FA',
  '--neutral-light-1': '#A2A8C2',
  '--neutral-light-2': '#9399B3',
  '--neutral-light-3': '#868AA4',
  '--neutral-light-4': '#777C96',
  '--neutral-light-5': '#696D88',
  '--neutral-light-6': '#5A5E78',
  '--neutral-light-7': '#4E4F6A',
  '--neutral-light-8': '#3F415B',
  '--neutral-light-9': '#393A54',
  '--neutral-light-10': '#35364F',
  '--white': '#32334D',
  '--darkmode-static-white': 'var(--static-white)',

  '--page-header-gradient-color-1': '#7652CC',
  '--page-header-gradient-color-2': '#B05CE6',

  '--tile-shadow-1': 'rgba(17,17,34,0.1)',
  '--tile-shadow-2': '#35364F',
  '--tile-shadow-3': 'rgba(17,17,34,0.25)',
  '--tile-shadow-1-alt': 'rgba(17,17,34,0.2)',

  '--currently-playing-border': 'none',
  '--currently-playing-default-shadow': 'rgba(17, 17, 17, 0.1)',

  '--card-image-shadow': 'rgba(17,17,17,.25)',

  '--search-bar-background': 'rgba(76,80,107,.8)',
  '--search-bar-expanded': 'rgba(76,80,107,1.0)',
  '--search-bar-border': 'rgba(143,149,152,0.1)',
  '--search-bar-shadow': 'rgba(36,36,56,0.2)',

  '--nav-column-group-header': 'var(--neutral-light-6)',
  '--nav-column-link': 'var(--neutral-light-2)',
  '--nav-column-link-hover': 'var(--neutral-light-1)',

  '--slider-handle': 'var(--neutral-dark-2)',

  '--table-shadow': 'rgba(17, 17, 34, 0.15)',

  '--mask': 'rgba(36, 36, 52, .7)',
  '--skeleton-gradient':
    'linear-gradient(90deg, #393A54 25%, #35364F 37%, #393A54 63%)',
  '--skeleton': '#393A54',
  '--profile-completion-shadow-1': 'rgba(0,0,0,0)',
  '--profile-completion-shadow-2': 'rgba(17, 17, 34, 0.15)',

  '--default-profile-picture-background': 'var(--neutral-light-6)',

  '--notification-panel-box-shadow': 'rgba(0,0,0,0.25)',
  '--notification-border': 'rgba(133,129,153,0.2)',
  '--notification-background': '#32334D',
  '--notification-border-hover': 'rgba(133,129,153,0.2)',
  '--notification-background-hover': '#32334D',
  '--notification-background-box-shadow': '0 2px 15px -4px rgba(17,17,34,0.2)',
  '--notification-border-active': '#4E4F6A',
  '--notification-background-active': '#2F3048',

  '--notification-unread-border': '#4E4F6A',
  '--notification-unread-background': '#3F415B',
  '--notification-unread-border-hover': '#4E4F6A',
  '--notification-unread-background-hover': '#3F415B',
  '--notification-unread-background-box-shadow': 'none',
  '--notification-unread-border-active': '#4E4F6A',
  '--notification-unread-background-active': '#363751',

  '--page-header-gradient':
    'linear-gradient(-22deg, var(--page-header-gradient-color-1) 0%, var(--page-header-gradient-color-2) 100%)',
  '--secondary-gradient': 'linear-gradient(315deg, #6B0FB3 0%, #7E1BCC 100%)',
  '--page-header-gradient-1': 'rgb(53,54,79)',
  '--page-header-gradient-2': 'rgba(53,54,79,0.85)',
  '--page-header-gradient-2-alt': 'rgba(53,54,79,0.95)',
  '--page-header-text-shadow-color': 'rgba(162,47,235,0.2)',
  '--page-header-text-shadow':
    '0px 2px 4px var(--page-header-text-shadow-color)',
  '--next-and-previous-buttons': 'var(--neutral)',

  '--segmented-progress-bar-segment-1':
    'linear-gradient(180deg, #ED75F9 0%, #CC0FE0 100%)',
  '--segmented-progress-bar-segment-2':
    'linear-gradient(180deg, #E477FB 0%, #B815DB 100%)',
  '--segmented-progress-bar-segment-3':
    'linear-gradient(180deg, #D069F5 0%, #9F0AD4 100%)',
  '--segmented-progress-bar-segment-4':
    'linear-gradient(180deg, #CC75FA 0%, #8908CE 100%)',
  '--segmented-progress-bar-segment-5':
    'linear-gradient(180deg, #AF4DFF 0%, #7305C8 100%)',
  '--segmented-progress-bar-segment-6':
    'linear-gradient(180deg, #9C45FF 0%, #5C03C2 100%)',
  '--segmented-progress-bar-segment-7':
    'linear-gradient(180deg, #833BFB 0%, #4600BC 100%)',

  '--play-button-triangle': 'var(--static-white)',
  '--action-sheet-text': 'var(--secondary)',
  '--track-slider-rail': 'var(--neutral)',
  '--track-slider-handle': 'var(--static-white)',
  '--stat-tile-text': 'var(--secondary-dark-1)'
}

export default theme
